import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=53f203d0&scoped=true&"
import script from "./realName.vue?vue&type=script&lang=js&"
export * from "./realName.vue?vue&type=script&lang=js&"
import style0 from "./realName.vue?vue&type=style&index=0&lang=css&"
import style1 from "./realName.vue?vue&type=style&index=1&id=53f203d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f203d0",
  null
  
)

export default component.exports